var map = {
	"./testMassage.png": "fb3d",
	"./三叉神经痛1-四白.png": "d34d",
	"./三叉神经痛2-颧髎.png": "7674",
	"./三叉神经痛3-下关.png": "c55f",
	"./三叉神经痛4-翳风.png": "c8f6",
	"./中风后遗症1-曲池.png": "6f28",
	"./中风后遗症2-足三里.png": "a412",
	"./中风后遗症3-三阴交.png": "8869",
	"./中风后遗症4-涌泉.png": "f8f6",
	"./乳腺增生1-肩井.png": "4875",
	"./乳腺增生2-少府.png": "f9af",
	"./乳腺增生3-太冲.png": "e31d",
	"./乳腺增生4-大包.png": "8e09",
	"./便秘1-天枢.png": "bb7d",
	"./便秘2-大肠俞.png": "8a43",
	"./便秘3-支沟.png": "ba75",
	"./便秘4-上巨虚.png": "5de1",
	"./偏头痛1-太阳.png": "c925",
	"./偏头痛2-率谷.png": "3ac5",
	"./偏头痛3-肩井.png": "ff2e",
	"./偏头痛4-太冲.png": "1090",
	"./冠心病1-心俞.png": "7232",
	"./冠心病2-内关.png": "a497",
	"./冠心病3-神门.png": "566b",
	"./冠心病4-极泉.png": "9666",
	"./前列腺疾病1-中极.png": "07fb",
	"./前列腺疾病2-膀胱俞.png": "619a",
	"./前列腺疾病3-阴陵泉.png": "b401",
	"./前列腺疾病4-天井.png": "5368",
	"./十二指肠溃疡1-足三里.png": "dd51",
	"./十二指肠溃疡2-胃俞.png": "d677",
	"./十二指肠溃疡3-三阴交.png": "248d",
	"./十二指肠溃疡4-中脘.png": "d20d",
	"./咳嗽1-肺俞.png": "7d12",
	"./咳嗽2-尺泽.png": "cc2c",
	"./咳嗽3-列缺.png": "7f86",
	"./咳嗽4-太溪.png": "72dc",
	"./咽喉肿痛1-天突.png": "5801",
	"./咽喉肿痛2-人迎.png": "0c48",
	"./咽喉肿痛3-鱼际.png": "df4e",
	"./咽喉肿痛4-照海.png": "67f1",
	"./哮喘1-天突.png": "771c",
	"./哮喘2-人迎.png": "be6b",
	"./哮喘3-定喘.png": "e7e4",
	"./哮喘4-太渊.png": "73b1",
	"./坐骨神经痛1-环跳.png": "f362",
	"./坐骨神经痛2-阳陵泉.png": "011c",
	"./坐骨神经痛3-委中.png": "b0b9",
	"./坐骨神经痛4-承山.png": "cc28",
	"./失眠1-前发际线.png": "debf",
	"./失眠2-太阳.png": "0521",
	"./失眠3-三阴交.png": "71d8",
	"./失眠4-涌泉.png": "38fb",
	"./头晕1-神门.png": "0af8",
	"./头晕2-风池.png": "bb4d",
	"./头晕3-阳陵泉.png": "c77b",
	"./头晕4-涌泉.png": "1c4e",
	"./头痛1-百会.png": "df9e",
	"./头痛2-太阳.png": "4f0a",
	"./头痛3-太冲.png": "52d4",
	"./头痛4-合谷.png": "be54",
	"./小腿抽筋1-承山.png": "a1b4",
	"./小腿抽筋2-足三里.png": "dc7f",
	"./小腿抽筋3-阳陵泉.png": "12126",
	"./小腿抽筋4-太溪昆仑.png": "5907",
	"./心悸1-巨阙.png": "9842",
	"./心悸2-心俞.png": "97f8",
	"./心悸3-郄门.png": "34e9",
	"./心悸4-曲泽.png": "ee96",
	"./急性腰扭伤1-委中.png": "35d2",
	"./急性腰扭伤2-腰痛点.png": "a101",
	"./急性腰扭伤3-太溪昆仑.png": "d3e2",
	"./急性腰扭伤4-环跳.png": "cfa9",
	"./恶心呕吐1-膻中.png": "1d30",
	"./恶心呕吐2-天枢.png": "9b33",
	"./恶心呕吐3-内关.png": "1597",
	"./恶心呕吐4-胃俞.png": "2ab4",
	"./感冒1-迎香.png": "24b8",
	"./感冒2-风池.png": "15f1",
	"./感冒3-肩井.png": "9125",
	"./感冒4-曲池.png": "b808",
	"./慢性咽炎1-翳风.png": "9fad",
	"./慢性咽炎2-人迎.png": "cb8d",
	"./慢性咽炎3-内关.png": "ee56",
	"./慢性咽炎4-照海.png": "9611",
	"./慢性支气管炎1-肺俞.png": "d582",
	"./慢性支气管炎2-肾俞.png": "599f",
	"./慢性支气管炎3-中府.png": "a64d",
	"./慢性支气管炎4-合谷.png": "086f",
	"./慢性胃炎1-足三里.png": "1181",
	"./慢性胃炎2-三阴交.png": "e4c0",
	"./慢性胃炎3-中脘.png": "f3d6",
	"./慢性胃炎4-胃俞.png": "e905",
	"./慢性胆囊炎1-胆俞.png": "0d88",
	"./慢性胆囊炎2-外关.png": "5099",
	"./慢性胆囊炎3-阳陵泉.png": "2739",
	"./慢性胆囊炎4-胆囊.png": "13fa",
	"./慢性鼻炎1-百会.png": "61a8",
	"./慢性鼻炎2-迎香.png": "773e",
	"./慢性鼻炎3-印堂.png": "97b6",
	"./慢性鼻炎4-鼻翼.png": "d62a",
	"./打嗝1-中脘.png": "d918",
	"./打嗝2-缺盆.png": "ca05",
	"./打嗝3-内关.png": "2597",
	"./打嗝4-足三里.png": "a5ac",
	"./早泄1-肾俞.png": "afac",
	"./早泄2-关元.png": "8107",
	"./早泄3-三阴交.png": "207e",
	"./早泄4-太溪.png": "b682",
	"./更年期综合症1-印堂.png": "1eb4",
	"./更年期综合症2-脾俞.png": "7c81",
	"./更年期综合症3-三阴交.png": "6419",
	"./更年期综合症4-百会.png": "2d6e",
	"./月经不调1-肾俞.png": "51ea",
	"./月经不调2-三阴交.png": "f557",
	"./月经不调3-血海.png": "fb25",
	"./月经不调4-地机.png": "af76",
	"./湿疹1-脾俞.png": "5673",
	"./湿疹2-阴陵泉.png": "8fe2",
	"./湿疹3-曲池.png": "b883",
	"./湿疹4-三阴交.png": "5609",
	"./牙痛1-下关.png": "49b9",
	"./牙痛2-颊车.png": "314f",
	"./牙痛3-合谷.png": "17b5",
	"./牙痛4-陷谷.png": "76f1",
	"./痔疮1-长强.png": "50e7",
	"./痔疮2-承山.png": "25b6",
	"./痔疮3-百会.png": "43b3",
	"./痔疮4-涌泉.png": "bf39",
	"./痛经1-气海.png": "037c",
	"./痛经2-肾俞.png": "2bec",
	"./痛经3-血海.png": "d86a",
	"./痛经4-蠡沟.png": "72bc",
	"./痤疮1-下关.png": "2181",
	"./痤疮2-尺泽.png": "a4c0",
	"./痤疮3-天枢.png": "3673",
	"./痤疮4-内庭.png": "d0ba",
	"./白内障1-太阳.png": "030e",
	"./白内障2-太阳.png": "21a7",
	"./白内障3-风池.png": "b5fe",
	"./白内障4-攒竹.png": "406d",
	"./皮肤瘙痒症1-曲池.png": "0a13",
	"./皮肤瘙痒症2-神门.png": "7996",
	"./皮肤瘙痒症3-血海.png": "4283",
	"./皮肤瘙痒症4-三阴交.png": "f30e",
	"./神经衰弱1-百会.png": "b98f",
	"./神经衰弱2-风池.png": "d18a",
	"./神经衰弱3-劳宫.png": "e080",
	"./神经衰弱4-神门.png": "5500",
	"./类风湿性关节炎1-风池.png": "404a",
	"./类风湿性关节炎2-阳池.png": "d67c",
	"./类风湿性关节炎3-阴陵泉.png": "ebcb",
	"./类风湿性关节炎4-昆仑.png": "0511",
	"./糖尿病1-气海.png": "1684",
	"./糖尿病2-胃脘下俞.png": "6506",
	"./糖尿病3-血海.png": "1271",
	"./糖尿病4-桥弓.png": "af86",
	"./耳鸣1-听宫.png": "7591",
	"./耳鸣2-中渚.png": "1b8d",
	"./耳鸣3-足三里.png": "1cc6",
	"./耳鸣4-太溪.png": "9ade",
	"./肠鸣腹胀1-中脘.png": "7512",
	"./肠鸣腹胀2-神阙天枢.png": "8be9",
	"./肠鸣腹胀3-足三里.png": "882a",
	"./肠鸣腹胀4-公孙.png": "9c34",
	"./肩周炎1-肩髃.png": "418d",
	"./肩周炎2-肩贞.png": "a08d",
	"./肩周炎3-肩髎.png": "eecb",
	"./肩周炎4-肩井.png": "e857",
	"./肺炎1-大椎.png": "4e98",
	"./肺炎2-膻中.png": "9dcd",
	"./肺炎3-风池.png": "bf10",
	"./肺炎4-尺泽.png": "6be2",
	"./胃下垂1-神阙.png": "8879",
	"./胃下垂2-气海.png": "eaf0",
	"./胃下垂3-胃俞.png": "d970",
	"./胃下垂4-足三里.png": "5fc2",
	"./胸闷1-内关.png": "c0c4",
	"./胸闷2-外关.png": "a268",
	"./胸闷3-膻中.png": "4248",
	"./胸闷4-三阴交.png": "292f",
	"./脂肪肝1-肝俞.png": "7b9c",
	"./脂肪肝2-脾俞.png": "ebed",
	"./脂肪肝3-足三里.png": "1e13",
	"./脂肪肝4-三阴交.png": "0b0d",
	"./腰椎间盘突出症1-大肠俞.png": "8b25",
	"./腰椎间盘突出症2-委中.png": "c032",
	"./腰椎间盘突出症3-阳陵泉.png": "60e1",
	"./腰椎间盘突出症4-腰痛点.png": "8e92",
	"./腰肌劳损1-腰痛点.png": "b1a0",
	"./腰肌劳损2-阳陵泉.png": "3a15",
	"./腰肌劳损3-腰眼.png": "dce8",
	"./腰肌劳损4-肾俞.png": "7349",
	"./腹泻1-大椎.png": "5353",
	"./腹泻2-中脘神阙.png": "809b",
	"./腹泻3-足三里.png": "6047",
	"./腹泻4-上廉下廉.png": "13b9",
	"./荨麻疹1-曲池.png": "55c7",
	"./荨麻疹2-合谷.png": "bcbf",
	"./荨麻疹3-阴陵泉.png": "83f7",
	"./荨麻疹4-血海.png": "9f10",
	"./足跟痛1-大钟.png": "2b2f",
	"./足跟痛2-昆仑太溪.png": "55e0",
	"./足跟痛3-仆参.png": "f34f",
	"./足跟痛4-涌泉.png": "51f4",
	"./过敏性鼻炎1-太阳.png": "495d",
	"./过敏性鼻炎2-印堂.png": "fa25",
	"./过敏性鼻炎3-迎香.png": "bda1",
	"./过敏性鼻炎4-风池.png": "5fde",
	"./遗精1-关元.png": "5b09",
	"./遗精2-肾俞.png": "a9dc",
	"./遗精3-太溪.png": "a7b0",
	"./遗精4-足三里.png": "8c6c",
	"./闭经1-肾俞.png": "ece2",
	"./闭经2-血海.png": "0b46",
	"./闭经3-三阴交.png": "2366",
	"./闭经4-足三里.png": "3c37",
	"./阳痿1-关元.png": "385a",
	"./阳痿2-肾俞.png": "b8b5",
	"./阳痿3-会阴.png": "711e",
	"./阳痿4-太冲.png": "e619",
	"./面神经麻痹1-丝竹空.png": "8d3f",
	"./面神经麻痹2-四白.png": "ab6a",
	"./面神经麻痹3-地仓.png": "495f",
	"./面神经麻痹4-翳风.png": "56b0",
	"./颈椎病1-风池.png": "6d5e",
	"./颈椎病2-大椎.png": "2ea9",
	"./颈椎病3-肩井.png": "af06",
	"./颈椎病4-手三里.png": "c9a7",
	"./高脂血症1-膻中.png": "fb38",
	"./高脂血症2-中脘.png": "c687",
	"./高脂血症3-丰隆.png": "42e5",
	"./高脂血症4-合谷.png": "c2f9",
	"./高血压1-合谷.png": "5818",
	"./高血压2-内关.png": "26e2",
	"./高血压3-曲池.png": "210e",
	"./高血压4-太阳.png": "7e34",
	"./黄褐斑1-肾俞.png": "d0fc",
	"./黄褐斑2-血海.png": "b733",
	"./黄褐斑3-复溜.png": "a7ab",
	"./黄褐斑4-太冲.png": "8340"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41cd";